import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.widget.all.product');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-widget-all-product',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.widget.all.product/view.scss */
/* src/app/component.widget.all.product/view.scss: no such file or directory */`],
})
export class ComponentWidgetAllProductComponent implements OnInit {
    @Input() value: number | null = null;
    
    public async ngOnInit() {
    }
}

export default ComponentWidgetAllProductComponent;